import { useCallback } from 'react';
import { useAppSelector } from '@redux/hooks';
import { useUserProfile } from '@entities/User';
import { getAuthUserData } from '@entities/Auth';
import { useRouter } from 'next/router';
import { SkeletonLoading } from '@app/shared';
import { IconChevronRight, IconSetting } from '@koleso-icons';
import { useWindowSizing } from '@app/hooks/useSizeWindow';
import classNames from 'classnames';

import styles from './shortProfile.module.scss';

export const ShortProfile = ({ className }: { className?: string }) => {
  const router = useRouter();
  const isMobile = useWindowSizing(990);
  const authData = useAppSelector(getAuthUserData);
  const { isLoading: isLoadedProfile, profile: userProfile } = useUserProfile();

  const handlerRouteInfo = useCallback(async () => {
    await router.push('/personal/info');
  }, []);

  const handlerRouteSetting = useCallback(async () => {
    await router.push('/personal/setting');
  }, []);

  if (isLoadedProfile) {
    return <SkeletonLoading width={'187px'} height={'54px'} />;
  }

  return (
    <div className={classNames(styles.Wrapper, className)}>
      <div className={styles.Container}>
        <div className={styles.Phone} onClick={handlerRouteInfo}>
          {authData?.userPhone}
          <IconChevronRight width={16} height={16} />
        </div>
        {isMobile && (
          <div onClick={handlerRouteSetting} className={styles.Setting}>
            <IconSetting width={24} height={24} />
          </div>
        )}
      </div>
      <div onClick={handlerRouteInfo} className={classNames(styles.Name, { [styles.Hide]: !userProfile?.firstName })}>
        {userProfile?.firstName && userProfile?.surName && `${userProfile?.firstName} ${userProfile?.surName}`}
      </div>
    </div>
  );
};
